import styled from 'styled-components'
import { Button } from '@qonsoll/react-design'

const ButtonStyled = styled(Button)`
  color: var(--facebook-button-default-color);
  background-color: var(--facebook-button-default-bg);

  &:hover,
  &:focus {
    color: var(--facebook-button-hover-color);
    background-color: var(--facebook-button-hover-bg);
  }
`

export default ButtonStyled
